import { useCallback } from 'react';
import { HapticPresets, hapticImpact, HapticType } from '../utils/haptic';

/**
 * Хук для работы с тактильными вибрациями в компонентах
 * @returns {Object} - Методы для различных типов вибраций
 */
export const useHaptic = () => {
  // Обертка для методов с useCallback для оптимизации
  const buttonPress = useCallback(() => {
    HapticPresets.buttonPress();
  }, []);

  const buttonPressImportant = useCallback(() => {
    HapticPresets.buttonPressImportant();
  }, []);

  const buttonPressCritical = useCallback(() => {
    HapticPresets.buttonPressCritical();
  }, []);

  const toggle = useCallback(() => {
    HapticPresets.toggle();
  }, []);

  const modalOpen = useCallback(() => {
    HapticPresets.modalOpen();
  }, []);

  const modalClose = useCallback(() => {
    HapticPresets.modalClose();
  }, []);

  const success = useCallback(() => {
    HapticPresets.success();
  }, []);

  const error = useCallback(() => {
    HapticPresets.error();
  }, []);

  const warning = useCallback(() => {
    HapticPresets.warning();
  }, []);

  const navigation = useCallback(() => {
    HapticPresets.navigation();
  }, []);

  const fileUpload = useCallback(() => {
    HapticPresets.fileUpload();
  }, []);

  const deleteAction = useCallback(() => {
    HapticPresets.delete();
  }, []);

  const itemSelect = useCallback(() => {
    HapticPresets.itemSelect();
  }, []);

  const stampPlace = useCallback(() => {
    HapticPresets.stampPlace();
  }, []);

  const documentSign = useCallback(() => {
    HapticPresets.documentSign();
  }, []);

  // Кастомная вибрация
  const custom = useCallback((style = HapticType.LIGHT) => {
    hapticImpact(style);
  }, []);

  return {
    buttonPress,
    buttonPressImportant,
    buttonPressCritical,
    toggle,
    modalOpen,
    modalClose,
    success,
    error,
    warning,
    navigation,
    fileUpload,
    delete: deleteAction,
    itemSelect,
    stampPlace,
    documentSign,
    custom,
  };
};

export default useHaptic;







